import { addDaysToDate, customFormat, DATE_VALUES, dateFormats } from 'utils/dateUtils'

import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { GET_EMAIL_PREVIEW_ASYNC } from '../WizardCampaign/steps/MessageStep/constants'
import { DEFAULT_COLLECTION_PERIOD } from '../WizardCampaign/WizardTrainingCampaign/constants'

import { EMERGENCY_STOP_REQUEST_ASYNC } from './CampaignReport/constants'
import {
  CAMPAIGN_TYPE_FILTER_CHANGE,
  CANCEL_CAMPAIGN_ASYNC,
  CHANGE_SELECTION_DATA,
  COPY_CAMPAIGN_ASYNC,
  DATA_REQUEST_ASYNC,
  DATE_FILTER_CHANGE,
  DELETE_CAMPAIGN_ASYNC,
  END_CAMPAIGN_ASYNC,
  GET_RECOMMENDED_CAMPAIGNS,
  LANGUAGES_FILTER_CHANGE,
  LAUNCH_TYPE_FILTER_CHANGE,
  PAGINATE_CHANGE,
  RECOMMENDED_CAMPAIGN_DEFAULT_DURATION,
  RECOMMENDED_CAMPAIGN_START_HOURS,
  RESET_FILTERS,
  RESET_RECOMMENDED_PREVIEW_DATA,
  SAVE_DRAFT_ASYNC,
  SEARCH_CHANGE,
  SET_RECOMMENDED_PREVIEW_DATA,
  SORT_PROPERTY_CHANGE,
  STATUS_FILTER_CHANGE,
  TOGGLE_ACTIVITY_STATUS_ASYNC,
} from './constants'

const DEFAULT_SELECTION_DATA = {
  selectionIds: [],
  allItems: false,
}

const initialState = {
  data: {
    items: [],
  },
  page: 1,
  campaignsLoader: false,
  recommendedCampaignsLoader: false,
  error: null,
  search: '',
  dateFilter: DATE_VALUES.ALL_TIME,
  statusFilter: [],
  launchTypeFilter: [],
  languagesFilter: [],
  campaignTypeFilter: [],
  sortProperty: '', // first_name-desc
  message: null,
  recommendedCampaigns: {
    items: [],
    meta: {},
  },
  recommendedPreviewData: {
    data: {},
  },
  selectionData: DEFAULT_SELECTION_DATA,
}

export default function () {
  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_CHANGE:
        return {
          ...state,
          search: action.payload.q,
          page: 1,
          campaignsLoader: true,
          error: null,
        }
      case CHANGE_SELECTION_DATA:
        return {
          ...state,
          selectionData: {
            ...state.selectionData,
            [action.payload.field]: action.payload.value,
          },
        }
      case SORT_PROPERTY_CHANGE:
        return {
          ...state,
          sortProperty: action.payload.value,
          campaignsLoader: true,
        }
      case DATE_FILTER_CHANGE:
        return {
          ...state,
          dateFilter: action.payload.dateFilter,
          campaignsLoader: true,
        }
      case CAMPAIGN_TYPE_FILTER_CHANGE:
        return {
          ...state,
          campaignTypeFilter: action.payload.campaignTypeArray,
          page: 1,
          campaignsLoader: true,
          message: null,
          error: null,
        }
      case LANGUAGES_FILTER_CHANGE:
        return {
          ...state,
          languagesFilter: action.payload.languagesArray,
          page: 1,
          campaignsLoader: true,
          message: null,
          error: null,
        }
      case STATUS_FILTER_CHANGE:
        return {
          ...state,
          statusFilter: action.payload.statusArray,
          page: 1,
          campaignsLoader: true,
          message: null,
          error: null,
        }
      case LAUNCH_TYPE_FILTER_CHANGE:
        return {
          ...state,
          launchTypeFilter: action.payload.value,
          page: 1,
          campaignsLoader: true,
          message: null,
          error: null,
        }
      case COMPANY_FILTER_CHANGE:
        return {
          ...state,
          page: 1,
          campaignsLoader: true,
          recommendedCampaignsLoader: true,
          message: null,
          error: null,
          sortProperty: '', // first_name-desc
        }
      case PAGINATE_CHANGE:
        return {
          ...state,
          page: action.payload.page,
          campaignsLoader: true,
          message: null,
          error: null,
        }
      case DATA_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          campaignsLoader: true,
          message: null,
        }
      case DATA_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          error: null,
          data: {
            ...action.payload.data,
            items: action.payload.data.items,
          },
          campaignsLoader: false,
        }
      case DATA_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          message: null,
          campaignsLoader: false,
        }
      case DATA_REQUEST_ASYNC.CANCEL:
        return { ...state, campaignsLoader: false, page: 1 }
      case EMERGENCY_STOP_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Campaign stopped successfully!',
        }
      case EMERGENCY_STOP_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error.response ? action.error.response.message : null,
        }
      case TOGGLE_ACTIVITY_STATUS_ASYNC.INITIATE:
      case COPY_CAMPAIGN_ASYNC.INITIATE:
        return {
          ...state,
          campaignsLoader: true,
          message: null,
        }
      case COPY_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          campaignsLoader: false,
          message: action.payload.response?.templates_cleared_campaign_ids?.length
            ? 'Campaigns copied as drafts. Reselect templates before launching the affected copies.'
            : 'Campaign copied successfully!',
        }
      case TOGGLE_ACTIVITY_STATUS_ASYNC.ERROR:
      case COPY_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          campaignsLoader: false,
          error: action.error.response ? action.error.response.message : null,
        }
      case TOGGLE_ACTIVITY_STATUS_ASYNC.SUCCESS:
        return {
          ...state,
          campaignsLoader: false,
          message: 'Campaign activity status toggled successfully!',
        }
      case CANCEL_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Campaign canceled successfully!',
        }
      case CANCEL_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          error: action.error.detail,
        }
      case END_CAMPAIGN_ASYNC.INITIATE:
        return {
          ...state,
          message: null,
        }
      case END_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          message: 'Closing the campaign, campaign summary will be available in a few minutes',
        }
      case END_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          error: action.error.response ? action.error.response.message : null,
        }
      case DELETE_CAMPAIGN_ASYNC.INITIATE:
        return {
          ...state,
          campaignsLoader: true,
          message: null,
        }
      case DELETE_CAMPAIGN_ASYNC.SUCCESS:
        return {
          ...state,
          campaignsLoader: false,
          message: 'Campaign deleted successfully!',
        }
      case DELETE_CAMPAIGN_ASYNC.ERROR:
        return {
          ...state,
          campaignsLoader: false,
          error: action.error.detail,
          message: action.error.detail,
        }
      case GET_RECOMMENDED_CAMPAIGNS.INITIATE:
        return {
          ...state,
          recommendedCampaignsLoader: true,
        }
      case GET_RECOMMENDED_CAMPAIGNS.SUCCESS:
        return {
          ...state,
          recommendedCampaignsLoader: false,
          recommendedCampaigns: action.payload.data,
        }
      case GET_RECOMMENDED_CAMPAIGNS.ERROR:
        return {
          ...state,
          error: action.error,
          recommendedCampaignsLoader: false,
        }
      case SET_RECOMMENDED_PREVIEW_DATA: {
        const launchDate = customFormat(
          addDaysToDate(new Date(), 1).setHours(RECOMMENDED_CAMPAIGN_START_HOURS, 0, 0, 0),
          dateFormats.secondary
        )
        const endDate = customFormat(
          addDaysToDate(new Date(launchDate), RECOMMENDED_CAMPAIGN_DEFAULT_DURATION),
          dateFormats.primary
        )
        const closeTime = addDaysToDate(endDate, DEFAULT_COLLECTION_PERIOD)

        return {
          ...state,
          recommendedPreviewData: {
            ...action.payload.data,
            launchDate,
            closeTime,
            endDate,
          },
        }
      }
      case RESET_RECOMMENDED_PREVIEW_DATA:
        return {
          ...state,
          recommendedPreviewData: {
            data: {},
          },
        }
      case SAVE_DRAFT_ASYNC.INITIATE:
        return {
          ...state,
          recommendedPreviewData: {
            ...state.recommendedPreviewData,
            loader: true,
          },
        }
      case SAVE_DRAFT_ASYNC.SUCCESS:
        return {
          ...state,
          recommendedPreviewData: {
            ...state.recommendedPreviewData,
            createdCampaignId: action.payload.id,
            loader: false,
          },
        }
      case SAVE_DRAFT_ASYNC.ERROR:
        return {
          ...state,
          recommendedPreviewData: {
            ...state.recommendedPreviewData,
            loader: false,
            error: action.payload.error,
          },
        }
      case GET_EMAIL_PREVIEW_ASYNC.SUCCESS:
        return {
          ...state,
          recommendedPreviewData: {
            ...state.recommendedPreviewData,
            emailPreview: action.payload.data.response.body,
            data: {
              ...state.recommendedPreviewData.data,
              previewSubject: action.payload.data.response.subject,
            },
          },
        }
      case GET_EMAIL_PREVIEW_ASYNC.ERROR:
        return {
          ...state,
          recommendedPreviewData: {
            ...state.recommendedPreviewData,
            error: action.payload.error,
          },
        }
      case RESET_FILTERS:
        return {
          ...state,
          search: '',
          dateFilter: DATE_VALUES.ALL_TIME,
          campaignTypeFilter: [],
          languagesFilter: [],
          statusFilter: [],
          launchTypeFilter: [],
          page: 1,
        }
      default:
        return state
    }
  }
}
